import React from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-custom-build/build/ckeditor';
import { connect } from 'react-redux';

import './style.css';
import { API_URL } from '../../../utils/constants';

const Editor = ({ placeholder = '', onChange = () => {}, value = '', userInfo = {} }) => (
  <div className="editor">
    <CKEditor
      data={value}
      editor={ClassicEditor}
      config={{
        placeholder,
        toolbar: {
          items: [
            'heading',
            '|',
            'fontFamily',
            'fontSize',
            'fontColor',
            'fontBackgroundColor',
            '|',
            'bold',
            'italic',
            'underline',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'alignment',
            'indent',
            'outdent',
            '|',
            'imageUpload',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            '|',
            'undo',
            'redo',
          ],
        },
        language: 'vi',
        image: {
          toolbar: [
            'imageTextAlternative',
            'imageStyle:full',
            'imageStyle:side',
          ],
        },
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells',
            'tableProperties',
            'tableCellProperties',
          ],
        },
        simpleUpload: {
          uploadUrl: `${API_URL}/upload/ckeditor`,
          headers: {
            Authorization: userInfo && userInfo.token,
          },
        },
      }}
      onInit={() => {
        // console.log('Editor is ready to use!', editor);
      }}
      onChange={(event, editor) => {
        const data = editor.getData();
        onChange({ event, editor, data });
      }}
    />
  </div>
);

export default connect(state => ({
  userInfo: state.user.info,
}))(Editor);



// WEBPACK FOOTER //
// ./src/components/elements/Editor/Editor.js